import { Edit } from "@wix/wix-ui-icons-common";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { ToolbarButton } from "./../../_shared/toolbar-button/toolbar-button.js";
const ImageEditorButton = ({ toolbarItem, dataHook }) => {
  const { t } = useContext(RicosContext) || {};
  const onClick = toolbarItem.commands.click;
  const node = toolbarItem.attributes.selectedNode;
  const src = node?.attrs.image?.src?.id;
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      prefix: Edit,
      onClick: () => onClick({ src }),
      dataHook,
      ariaLabel: t("ImageEditorButton_Tooltip"),
      tooltip: t("ImageEditorButton_Tooltip"),
      disabled: !src,
      tabIndex: toolbarItem.presentation.tabIndex
    }
  );
};
var ImageEditorButton_default = ImageEditorButton;
export {
  ImageEditorButton_default as default
};
//# sourceMappingURL=ImageEditorButton.js.map
